import i18next from 'i18next';

export const custom = {
  practice: {
    required: i18next.t('The practice must be selected.'),
    min_value: i18next.t('The practice must be selected.'),
  },
};
